import { defineMessages } from "react-intl";
const messages = defineMessages({
    addSubtopicButton: {
        id: "app.aiDiscoverability.customSubtopics.addSubtopic",
        defaultMessage: "Add Subtopic",
    },
    cancelButton: {
        id: "app.aiDiscoverability.customSubtopics.cancel",
        defaultMessage: "Cancel",
    },
    editTooltip: {
        id: "app.aiDiscoverability.customSubtopics.editTooltip",
        defaultMessage: "Edit",
    },
    removeTooltip: {
        id: "app.aiDiscoverability.customSubtopics.removeTooltip",
        defaultMessage: "Remove",
    },
    allSubtopicsUsedTitle: {
        id: "app.aiDiscoverability.customSubtopics.allSubtopicsUsedTitle",
        defaultMessage: "All {max} Subtopics Used",
    },
    allSubtopicsUsedDescription: {
        id: "app.aiDiscoverability.customSubtopics.allSubtopicsUsedDescription",
        defaultMessage: "If you'd like to add another, remove existing subtopics.",
    },
});
export default messages;
